import {
  CubeReducerState,
  DisabledReasonType,
  VisibleEnabledFeatureAvailable
} from 'modules/Cube/domain/cube.domain.types'

/**
 * An amendment quote is built against an existing schedule, so its currency has
 * to stay as that schedule's. Archived, signed and executed quotes already lock
 * every control via `maybeDisabledOverride` in `useQuoteEditorSidebar`, so this
 * only covers the amendment case.
 */
export const getEditCurrencyAvailable = (
  prevState: CubeReducerState
): VisibleEnabledFeatureAvailable => {
  if (prevState.data.quote.dealType === 'AMENDMENT') {
    return {
      available: {
        visible: true,
        enabled: false
      },
      reasons: [
        {
          reasonType: DisabledReasonType.CantChangeOnAmendmentDealType,
          metadata: {}
        }
      ]
    }
  }

  return {
    available: {
      visible: true,
      enabled: true
    },
    reasons: []
  }
}
